import merchantObj from './merchant'
export default Object.assign({}, merchantObj)
